import { useQuery } from '@tanstack/react-query';
import { apiClientV2 } from '~/api/client';

export const useSearchAgencyCreator = (keyword: string, agencyId: string) => {
  return useQuery({
    queryKey: ['AGENCY_CREATOR_SEARCH', { keyword, agencyId }],
    queryFn: () =>
      apiClientV2
        .get(`/agencies/${agencyId}/creators`, {
          params: {
            'filter[]': `keyword:${keyword}`,
            pageSize: 5,
          },
        })
        .then((r) => r.data['hydra:member']),
    enabled: keyword.length > 2,
  });
};
